import React from 'react';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import { AnswerLink } from '../../components/Step/AnswerLink';
import { STEP_PRODUCT_PREFERENCES } from '../constants';
import type { SelectedValues } from '../config';
import type { ProductPreferences } from './ProductPreferencesStepInputs';

export interface ProductPreferencesStepAnswerProps {
    link: string;
    data: SelectedValues;
    onClick: () => void;
}

const productAnswers = (): Record<ProductPreferences, string> => ({
    'colors-fonts': __('colors and fonts'),
    website: __('a website'),
    'social-media': __('social media'),
    'brand-guidelines': __('brand guidelines'),
    brochures: __('brochures'),
    stationery: __('stationery'),
    'product-packaging': __('product packaging'),
    signage: __('signage'),
    'product-labels': __('product labels'),
    'business-cards': __('business cards'),
    other: __('other things'),
});

export function ProductPreferencesStepAnswer({
    data,
    link,
    onClick,
}: ProductPreferencesStepAnswerProps) {
    const values = data[STEP_PRODUCT_PREFERENCES];

    if (!values) {
        return null;
    }

    values.push(values.splice(values.indexOf('other'), 1)[0]);
    const answerItems = values.map((value) => productAnswers()[value]);

    let answer = '';
    const wordJoinText = ` ${__('and')} `;

    if (answerItems.length === 2) {
        answer = answerItems.join(wordJoinText);
    } else if (answerItems.length > 2) {
        answer = answerItems.slice(0, -1).join(', ') + wordJoinText + answerItems.slice(-1);
    } else {
        answer = answerItems[0];
    }

    return (
        <FormattedMessage
            message={__('I also need {product_preferences} for my brand.')}
            values={{
                product_preferences: (
                    <AnswerLink href={link} onClick={onClick}>
                        {answer}
                    </AnswerLink>
                ),
            }}
        />
    );
}
